import styles from './Feature2.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

export interface featureArrayDetail {
  imgSrc: string
  title: string
  text: string
}

export interface FeatureItem2 {
  sectionRead: string
  featureArray: featureArrayDetail[]
}

interface Props {
  FeatureEach2: FeatureItem2[]
}

const Feature2: React.FC<Props> = ({ FeatureEach2 }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  const item = FeatureEach2[0]

  return (
    <section
      className={`${styles.feature2} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>特長・強み</h2>
      <p className={styles.sectionRead}>{item.sectionRead}</p>
      <div className={styles.wrapper}>
        {item.featureArray.map((feature, idx) => (
          <section className={styles.featureItem2} key={idx}>
            <div className={styles.featureItem2__title}>
              <img
                src={feature.imgSrc}
                alt={feature.title}
                width={40}
                height={40}
                className={styles.featureItem2__title__img}
              />
              <h3 className={styles.featureItem2__title__text}>{feature.title}</h3>
            </div>
            <p className={styles.featureItem2__text}>{feature.text}</p>
          </section>
        ))}
      </div>
    </section>
  )
}

export default Feature2
